<template>
  <div class="st-toolbar" :class="[`st-toolbar--${tone}`, { 'st-toolbar--wrap': wrap }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    /** `shell` sits on the dark frame; `canvas` sits on the light working area. */
    tone?: 'shell' | 'canvas';
    wrap?: boolean;
  }>(),
  { tone: 'shell' },
);
</script>

<style scoped>
.st-toolbar {
  display: flex;
  align-items: center;
  gap: var(--st-space-2);
  padding: var(--st-space-2) var(--st-space-4);
}
.st-toolbar--wrap {
  flex-wrap: wrap;
}
.st-toolbar--shell {
  background: var(--st-shell-bg-raised);
  border-bottom: 1px solid var(--st-shell-border);
  color: var(--st-shell-text);
}
.st-toolbar--canvas {
  background: var(--st-surface);
  border-bottom: 1px solid var(--st-border);
  color: var(--st-text);
}

/* A flexible gap that pushes following items to the right. */
.st-toolbar :deep(.st-toolbar-spacer) {
  flex: 1;
}
/* A thin vertical rule between groups. */
.st-toolbar :deep(.st-toolbar-divider) {
  width: 1px;
  align-self: stretch;
  margin: var(--st-space-1) var(--st-space-1);
  background: currentColor;
  opacity: 0.15;
}
</style>
